import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import GoonoThemeProvider, {
  GoonoTheme,
} from "@ui/goono/styles/GoonoThemeProvider";
import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import ContainerProvider from "./redux/container";
import { BrowserRouter } from "react-router-dom";
import GoonoRoutingManager from "./routes/GoonoRoutingManager";
import { PDFDownloadModalProvider } from "./context/PDFDownloadModalContext";
import { HelmetProvider } from "react-helmet-async";

export default function App() {
  return (
    <Provider store={store}>
      <EmotionThemeProvider theme={GoonoTheme}>
        <GoonoThemeProvider>
          <PersistGate loading={null} persistor={persistor}>
            <ContainerProvider>
              <PDFDownloadModalProvider>
                <HelmetProvider>
                  <BrowserRouter>
                    <GoonoRoutingManager />
                  </BrowserRouter>
                </HelmetProvider>
              </PDFDownloadModalProvider>
            </ContainerProvider>
          </PersistGate>
        </GoonoThemeProvider>
      </EmotionThemeProvider>
    </Provider>
  );
}
